/*@flow*/
import * as I from 'immutable';
import Present from 'lib/Present';

export default (o: Object) =>
  I.Map(o)
    .filter(v => Present.is(v))
    .toJS();
